import React, { useEffect } from 'react';

import FullscreenLoader from '../../components/FullscreenLoader';
import { IndexPath } from '../../routing';
import { useAuth } from 'oidc-react';
import { useHistory } from 'react-router-dom';

export default function SignInCallback() {
  const auth = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (auth.userData) {
      history.push({ pathname: IndexPath });
    }
  }, [auth.userData, history]);

  if (auth.isLoading) {
    return <FullscreenLoader />;
  }

  return null;
}
